import React from "react";
import CompanyOverviewTab from "../../components/tabs/CompanyOverviewTab/CompanyOverviewTab";

export default function Companies() {

  return (
    <CompanyOverviewTab />
  );
}
